import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { ApiConfigService } from './api-config.service'
import { AlertController } from '@ionic/angular'
import { Observable } from 'rxjs'
import { PushEventsRequest, PushEventType } from '@shared/models/notification'

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly http = inject(HttpClient)
  private readonly apiConfigService = inject(ApiConfigService)

  private alertController = inject(AlertController)

  private lastNotificationShowed = ''

  markNotificationAsReceived(idNotification: string): Observable<void> {
    return this.http.patch<void>(`${this.apiConfigService.API_NOTIFICATION}/${idNotification}`, {})
  }

  public async showNotificationDetails(data: {
    route?: string
    idNotification?: string
    title?: string
    body?: string
    message?: string
  }) {
    if (
      data &&
      data.route === 'admin-notification' &&
      data.idNotification &&
      data.idNotification !== this.lastNotificationShowed
    ) {
      const alert = await this.alertController.create({
        header: data.title,
        message: data.body,
        buttons: [
          {
            text: 'Ok',
            handler: async () => {
              this.lastNotificationShowed = ''
              alert.dismiss()
            },
          },
        ],
      })

      await alert.present()
      this.lastNotificationShowed = data.idNotification
    }
  }

  public trackNotificationAction(idNotification: string, data: PushEventsRequest) {
    return this.http.post<PushEventType>(
      `${this.apiConfigService.API_NOTIFICATION}/${idNotification}/push-events`,
      data,
    )
  }
}
